import DateFnsUtils from '@date-io/date-fns'
import { ThemeProvider, StylesProvider } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import ruLocale from 'date-fns/locale/ru'
import { SnackbarProvider } from 'notistack'
import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import 'react-image-lightbox/style.css'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { asterTheme } from 'asterX-UI'
import './index.css'
import './i18n'
import './lib/utils/strMethods'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthStoreProvider } from 'context/AuthStore'
import { ModalbarProvider } from 'modules/Modalbar'

ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={asterTheme}>
      <StylesProvider>
        <BrowserRouter>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              autoHideDuration={3000}
            >
              <ModalbarProvider>
                <Switch>
                  <Route
                    path="/"
                    render={props => (
                      <AuthStoreProvider {...props}>
                        <App {...props} />
                      </AuthStoreProvider>
                    )}
                  />
                </Switch>
              </ModalbarProvider>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </BrowserRouter>
      </StylesProvider>
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
